<template>
    <div class="col-5 col-md-2 toggler-wrapper">
        <div class="objects-counter">{{ getNumberObjects }} {{ $t('dashboard.objects') }}</div>
        <TogglerButton
                icon="geo-alt"
                :title="$t('dashboard.mapText')"
                :event-handler="() => $store.dispatch(map)"
                :is-active="isMapActive"
        ></TogglerButton>
        <TogglerButton
                class="mr-md-2"
                icon="list-ul"
                :title="$t('dashboard.listText')"
                :event-handler="() => $store.dispatch(list)"
                :is-active="isListActive"
        ></TogglerButton>
    </div>
</template>

<script>
    // utils
    import {SWITCH_MAP, SWITCH_LIST} from "../../store/actions/dashboard";
    import {mapGetters} from "vuex";
    // components
    import TogglerButton from "./TogglerButton";

    /**
     * Serves as a switch hub for the map and the table sub views.
     * Consists of two buttons.
     */

    export default {
        name: "MapTableSwitch",
        components: {TogglerButton},
        data() {
            return {
                map: SWITCH_MAP,
                list: SWITCH_LIST
            }
        },
        computed: {
            ...mapGetters(['getNumberObjects', 'isMapActive', 'isListActive']),
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/variables";

    /****************************************************************************
      NUMBER, MAP TOGGLER, LIST TOGGLER (RIGHT OF SEARCH)
    ****************************************************************************/
    .toggler-wrapper {
        height: 64px;
        padding: 0;
        border-left: 1px solid $lightGrey;
        /* center content */
        display: flex;
        justify-content: center;
        align-items: center;
    }

    /* -------- objects counter --------- */
    .objects-counter {
        text-align: right;
        font: 300 14px/40px Nunito, sans-serif;
        letter-spacing: 0px;
        color: $mediumGrey;
        opacity: 1;
        margin-right: 4%;
    }

    /* -------- fixes for mobile ---------- */
    @media screen and (min-width: 763px) and (max-width: 1050px) {
        .toggler-wrapper .objects-counter {
            line-height: 20px;
        }
    }

    @media screen and (max-width: 762px) {
        .toggler-wrapper {
            padding: 0;
        }

        .toggler-wrapper .objects-counter {
            text-align: center;
            margin: 0;
            font: 300 12px/20px Nunito, sans-serif;
        }
    }
    /****************************************************************************
      /NUMBER, MAP TOGGLER, LIST TOGGLER (RIGHT OF SEARCH)
     ****************************************************************************/
</style>